import { Outlet } from 'react-router';
import { useUser } from 'features/auth';
import { TimezoneConfirmationModal } from 'features/timezone';
import { useOnNavigateToProfile } from './hooks';

const TimezoneConfirmationGuard = () => {
  const navigateToChangeTimezone = useOnNavigateToProfile();
  const user = useUser({ requiredAuth: false });

  if (!user?.railsUserData) {
    return <Outlet />;
  }

  return (
    <>
      <TimezoneConfirmationModal navigateToChangeTimezone={navigateToChangeTimezone} viewer={user.railsUserData} />
      <Outlet />
    </>
  );
};

export default TimezoneConfirmationGuard;
